import React,{ useState,useEffect } from 'react';
import MaterialTable from 'material-table';
import { useSelector } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { useTranslation } from "react-i18next";
import {colors} from '../components/Theme/WebTheme';
import {
  Select,
  MenuItem,
  FormControl,
} from '@mui/material';
export default function DriverEarning() {
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  const countrylistdata = useSelector(state => state.countrylistdata);
  const userInfo = useSelector(state => state.auth.profile);
  const [countries, setCountries] = useState([]);
  const [countryList, setCountryList] = useState({});
  const driverearningdata = useSelector(state => state.driverearningdata);
  const [selectedCountry, setSelectedCountry] = useState(t('select_country'));
  const [selectedRow, setSelectedRow] = useState(null);

  const columns = React.useMemo(() => [
      { title: t('year'),field: 'year'},
      { title: t('months'), field: 'monthsName', },
      { title: t('country'), field: 'country', lookup: countryList },
      { title: t('driver_name'), field: 'driverName',},
      { title: t('booking_count'), field: 'total_rides', },
      { title: t('vehicle_reg_no'), field: 'driverVehicleNo', },
      { title: t('earning_amount'), field: 'driverShare', }
  ], [t, countryList]);

  const displayData = React.useMemo(() => {
    let result = driverearningdata.driverearnings || [];

    // 1. Filter by country if selected
    if (selectedCountry && selectedCountry !== t('select_country')) {
      result = result.filter(item => item.country === selectedCountry);
    }

    // 2. Filter by fleetadmin if user is fleetadmin
    if (userInfo?.usertype === 'fleetadmin') {
      result = result.filter(item => item.fleetadmin === userInfo.uid);
    }

    return result.map(item => ({...item}));
  }, [driverearningdata.driverearnings, selectedCountry, userInfo, t]);

  useEffect(() => {
    if (countrylistdata.countries) {
      setCountries(countrylistdata.countries);
      let list = {};
      for(let i=0; i<countrylistdata.countries.length; i++){
        let obj = countrylistdata.countries[i];
        list[obj.country_code] = t(obj.country);
      }
      setCountryList(list);
    }else{
      setCountries([]);
      setCountryList({});
    }
  }, [countrylistdata.countries, t]);

  const handleCountrySelect = (event) => {
    setSelectedCountry(event.target.value);
  }

  return (
    driverearningdata.loading? <CircularLoading/>:
    <div>
   <FormControl sx={{ m: 1, width: 300 }}>
       <Select
         labelId="demo-simple-select-label"
         id="demo-simple-select"
         value={selectedCountry}
         onChange={handleCountrySelect}
         style={{textAlign:isRTL==='rtl'? 'right':'left',border:'1px solid #9E9E9E'}}
       >
               <MenuItem value={t('select_country')} style={{direction:isRTL==='rtl'?'rtl':'ltr', width:'100%', justifyContent:'flex-start', paddingLeft:10}}>
            {t('select_country')}
          </MenuItem>
             {countries.map((item) =>
             <MenuItem dense={true}  key={item.country} value={item.country_code} style={{direction:isRTL==='rtl'?'rtl':'ltr', width:'100%', justifyContent:'flex-start', paddingLeft:10}}>
             {t(item.country)}</MenuItem>)}</Select>
    </FormControl>
    <MaterialTable
      title={t('driver_earning')}
      columns={columns}
      style={{direction:isRTL ==='rtl'?'rtl':'ltr', borderRadius: "8px", boxShadow: "4px 4px 6px #9E9E9E"}}
      data={displayData}
      onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
      options={{
        exportButton: true,
        grouping: true,
        rowStyle: rowData => ({
          backgroundColor: (selectedRow === rowData.tableData.id) ?  colors.THIRDCOLOR: colors.WHITE
        }),
        editable:{
          backgroundColor: colors.WHITE,
          fontSize: "0.8em",
          fontWeight: 'bold ',
          fontFamily: 'Lucida Console", "Courier New", monospace'
        },
        cellStyle:{ textAlign: 'center',
        border: "1px solid rgba(224, 224, 224, 1)",
      },
        headerStyle: {
          position: "sticky",
          textAlign:'center',
          top: "0px",
          backgroundColor: colors.SECONDARY ,
          color: colors.WHITE,
          fontSize: "0.8em",
          fontWeight: 'bold ',
          fontFamily: 'Lucida Console", "Courier New", monospace',
          border: "1px solid rgba(224, 224, 224, 1)",

        }
      }}
      localization={{
        toolbar: {
          searchPlaceholder: (t('search')),
          exportTitle: (t('export')),
        },
        pagination: {
          labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
          firstTooltip: (t('first_page_tooltip')),
          previousTooltip: (t('previous_page_tooltip')),
          nextTooltip: (t('next_page_tooltip')),
          lastTooltip: (t('last_page_tooltip'))
        },
      }}
    />
    </div>
  );
}
